import { render, staticRenderFns } from "./GdDetail.vue?vue&type=template&id=bf41b2c0&scoped=true"
import script from "./GdDetail.vue?vue&type=script&lang=js"
export * from "./GdDetail.vue?vue&type=script&lang=js"
import style0 from "./GdDetail.vue?vue&type=style&index=0&id=bf41b2c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf41b2c0",
  null
  
)

export default component.exports